import Vue from 'vue'
import store from '../../main/js/store'
import router from '../../main/js/router'
// import PortalVue from 'portal-vue'
import VueResource from 'vue-resource'
import * as VueGoogleMaps from 'vue2-google-maps'
import { VueHammer } from 'vue2-hammer'
import VueScrollTo from 'vue-scrollto'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import Signup from "@afrihost/vue-signup";
import "@afrihost/vue-signup/dist/afrihost-signup.css";

import axios from "axios";
const signalInstance = axios.create({
	baseURL: 'https://signal.afrihost.com/api/',
	withCredentials: true,
	headers: {
		'Accept': 'application/json',
		'Content-Type': 'application/json',
	}
})

if(window && process.env.MIX_SIGNAL_UUID) {


	const searchParams = new URLSearchParams(window.location.search);

	// signal page view
	let l = window.location
	let path = l.pathname
	let source = searchParams.get('utm_source')
	let medium = searchParams.get('utm_medium')
	let campaign = searchParams.get('utm_campaign')

	let event = {
		type: 'page-view',
		value: null,
		path: path,
		meta: null,
		campaign: campaign,
		medium: medium,
		source: source
	}

	signalInstance.post(`/public/project/${process.env.MIX_SIGNAL_UUID}/event`, event)

}

// Vue.use(PortalVue);
Vue.use(VueResource);
Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyB_jNrg_FCQ8F-nLgBhRNb9149pqIkIggo',
		libraries: 'places',
	},

	// If you intend to programmatically custom event listener code
	// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
	// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
	// you might need to turn this on.
	// autobindAllEvents: false,

	// If you want to manually install components, e.g.
	// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
	// Vue.component('GmapMarker', GmapMarker)
	// then disable the following:
	// installComponents: true,
});
Vue.use(VueHammer);
VueHammer.config.swipe = {
	direction: 6,
};

Vue.use(VueScrollTo, {
	container: "body",
	duration: 500,
	easing: "ease",
	offset: -60,
	force: true,
	cancelable: true,
	onStart: false,
	onDone: false,
	onCancel: false,
	x: false,
	y: true
});

Sentry.init({
	dsn: 'https://c33b28441b5b48d4a0b95fdef7828477@sentry.sys.afrihost.com/14',
	integrations: [new Integrations.Vue({ Vue, attachProps: true })],
	environment: process.env.NODE_ENV === 'production' ? 'production' : 'development',
});

Vue.use(Signup, {
	store: store,
	storeKey: process.env.MIX_SIGNUP_PLUGIN_STORE_KEY,
	solutionTypes: ['composite_fibre'],
	upsellSolutionTypes: ['connectivity_mobile'],
	googleMapsKey: 'AIzaSyB_jNrg_FCQ8F-nLgBhRNb9149pqIkIggo',
	pageRequestedFrom: process.env.MIX_SIGNUP_PLUGIN_PAGE_REQUESTED_FROM + "-provider",
	testSignup: process.env.MIX_SIGNUP_PLUGIN_TEST === "true",
	decoInStock: {
		twoPack: process.env.MIX_SIGNUP_PLUGIN_DECO_2_IN_STOCK === "true",
		threePack: process.env.MIX_SIGNUP_PLUGIN_DECO_3_IN_STOCK === "true",
	},
	fibreFreeze: process.env.MIX_SIGNUP_PLUGIN_FIBRE_FREEZE === "true",
	signalUuid: process.env.MIX_SIGNAL_UUID
})

import HeaderSearchBar from '../../main/js/views/HeaderSearchBar'
import Modal from '../../main/js/views/Modal'
import Modal5k from '../../main/js/components/Modal5k'
import ModalUpgradePromo from '../../main/js/components/ModalUpgradePromo'
import CoverageCheck from "../../main/js/views/CoverageCheck";
import ProviderPagePackages from "../../main/js/components/ProviderPagePackages.vue";
import InstallationFreeze from "../../main/js/modals/InstallationFreeze.vue";

new Vue({
	el: '.search-bar',
	store,
	router,
	render: h => h(CoverageCheck)
});

new Vue({
	el: 'signup-modal',
});

new Vue({
	el: 'fibre-modal',
	store,
	router,
	render: h => h(Modal)
});

new Vue({
	name: 'ProviderPackages',
	el: 'provider-page-packages',
	render: h => h(ProviderPagePackages)
})


new Vue({
	el: 'nav',
});

new Vue({
	el: 'installation-freeze',
	store,
	render: h => h(InstallationFreeze)
});


new Vue({
	el: '.freeze-banner',
	store,
	methods: {
		showFreezeModal() {
			this.$store.commit('general/updateFreezeModalVisibility', true);
		}
	}
});


new Vue({
	el: '[v-scroll-to]',
});

new Vue({
	el: '.signup-bar',
})

new Vue({
	el: 'modal-5k',
	store,
	render: h => h(Modal5k)
});

new Vue({
	el: 'modal-upgrade',
	store,
	render: h => h(ModalUpgradePromo)
});

new Vue({
	el: '.header-promo-bar',
	store,
	methods: {
		openPromoModal() {
			this.$store.commit('general/updatePromoModalVisibility', true);
		},
		toTerms() {
			this.$scrollTo('.provider-terms h5');
		}
	}
});

new Vue({
    el: '.provider-terms',
	store,
    data() {
        return {
            isCollapsed: false
        }
    },
    methods: {
		toggleExpand() {
        	this.isCollapsed = !this.isCollapsed;
		},
		openPromoModal() {
			this.$store.commit('general/updatePromoModalVisibility', true);
		}
    }
});
